import { SNACKBAR_BG_COLOR, SNACKBAR_TEXT_COLOR } from "@/constants/snackbar";
import { SNACKBAR_TYPE } from "@shared-types/snackbar";

export default class Snackbar {
  private static timeoutId: ReturnType<typeof setTimeout> | null = null;
  private static snackbarElem: HTMLDivElement | null = null;

  message: string = "";
  type: string = SNACKBAR_TYPE.SUCCESS;
  time: number = 3000;

  getErrorOutlineSvg(color: string = "currentColor"): string {
    return `<svg stroke=${color} fill=${color} stroke-width="0" viewBox="0 0 24 24" height="1.5rem" width="1.5rem" xmlns="http://www.w3.org/2000/svg"><path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path></svg>`;
  }

  getCheckCircleSvg(color: string = "currentColor"): string {
    return `<svg stroke=${color} fill=${color} stroke-width="0" viewBox="0 0 24 24" height="1.5rem" width="1.5rem" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>`;
  }

  getIcon(type: string = SNACKBAR_TYPE.SUCCESS): string {
    if (type === SNACKBAR_TYPE.SUCCESS) return this.getCheckCircleSvg();
    return this.getErrorOutlineSvg();
  }

  getSnackbarElement(
    message: string,
    type: SNACKBAR_TYPE = SNACKBAR_TYPE.SUCCESS
  ): HTMLDivElement {
    // TODO: Abhishek => Add document check, if document exists
    const snackbarContainer = document.createElement("div");
    snackbarContainer.className =
      "snackbarTopDownAnimation fixed rounded left-0 right-0 flex w-max max-w-full p-4 items-center m-auto";
    snackbarContainer.style.zIndex = "9999";
    snackbarContainer.style.background = SNACKBAR_BG_COLOR[type];
    snackbarContainer.style.color = SNACKBAR_TEXT_COLOR[type];

    const content = document.createElement("span");
    content.className = "text-sm font-medium";
    content.innerText = message;

    const iconContainer = document.createElement("span");
    iconContainer.style.marginRight = "0.5rem";
    const svgIcon = this.getIcon(type);
    iconContainer.innerHTML = svgIcon;

    snackbarContainer.append(...[iconContainer, content]);
    return snackbarContainer;
  }

  show(
    message: string = "",
    type: SNACKBAR_TYPE = SNACKBAR_TYPE.SUCCESS,
    time: number | "infinite" = 3000
  ): void {
    this.hide();
    Snackbar.snackbarElem = this.getSnackbarElement(message, type);
    const body = document.body;
    body.append(Snackbar.snackbarElem);
    if (time !== "infinite")
      Snackbar.timeoutId = setTimeout(() => {
        this.hide();
      }, time);
  }

  hide(): void {
    if (Snackbar.snackbarElem) Snackbar.snackbarElem.remove();
    if (Snackbar.timeoutId) clearTimeout(Snackbar.timeoutId);
    Snackbar.snackbarElem = null;
    Snackbar.timeoutId = null;
  }
}
